exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='user-admin'] .form-holder {\n  margin: 0 0 0 15px;\n}\n[data-component='user-admin'] .steps-container {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  margin: 0 0 40px;\n}\n[data-component='user-admin'] .step {\n  top: 0;\n  left: 150%;\n  position: absolute;\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/user-admin/user-admin.component.styl
// module id = ../../../../../src/app/master/user-admin/user-admin.component.styl
// module chunks = main